import React, { useState, useRef, useEffect } from "react";

const ShowMore = ({ text = "", maxLines = 3, width = "100%" }) => {
    const [expanded, setExpanded] = useState(false);
    const [needsToggle, setNeedsToggle] = useState(false);
    const textRef = useRef(null);

    const lineClampStyle = (expanded) ? {} : {
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    };

    const check = () => {
        const el = textRef.current;
        if (!el) return;
        const prev = el.style.webkitLineClamp;
        el.style.webkitLineClamp = "unset";
        const fullHeight = el.scrollHeight;
        el.style.webkitLineClamp = maxLines;
        const clampedHeight = el.clientHeight;
        setNeedsToggle(fullHeight > clampedHeight);
        el.style.webkitLineClamp = prev;
    }
    useEffect(() => {
        setTimeout(check, 100)
    }, [text, maxLines, width]);

    return (
        <div style={{ width }}>
            <div ref={textRef} style={lineClampStyle}>
                {text}
            </div>

            {needsToggle && (
                <span
                    onClick={() => setExpanded(!expanded)}
                    style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        userSelect: "none",
                        display: "inline-block",
                        marginTop: 4,
                    }}
                >
                    {expanded ? "show less" : "show more"}
                </span>
            )}
        </div>
    );
};

export default ShowMore;